import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Lenis smooth scroll (import dynamically to avoid SSR issues)
import Lenis from "lenis";

const rootElement = document.getElementById("root");

// Support react-snap hydration for SEO (React 19 compatible)
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Init Lenis smooth-scrolling
try {
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smooth: true,
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);
  // expose Lenis instance for use elsewhere (anchor scrolling)
  try {
    window.lenis = lenis;
  } catch (e) {
    // ignore in restrictive environments
  }

  // Intercept clicks on internal anchor links and use Lenis for smooth scroll
  document.addEventListener("click", (ev) => {
    const el = ev.target.closest && ev.target.closest('a[href^="#"]');
    if (!el) return;
    const href = el.getAttribute("href");
    if (!href || href === "#" || href === "#!") return;
    const id = href.slice(1);
    const target =
      document.getElementById(id) || document.getElementsByName(id)[0];
    if (target && window.lenis) {
      ev.preventDefault();
      // offset optional: 0, can be adjusted if navbar fixed
      window.lenis.scrollTo(target, { offset: -12 });
      // update hash without jumping
      window.history.replaceState(null, "", href);
    }
  });
} catch (e) {
  // If anything fails, don't block the app
  // console.warn('Lenis init failed', e);
}

// Perf
reportWebVitals();
